module.exports = __webpack_public_path__ + "static/media/school.c6e3f042.svg";